import { FC } from "react";

const MenuEngineering: FC = () => {
  return <div>Menu Engineering</div>;
};

export default MenuEngineering;
